import { AddAPhoto, Build, CallEnd } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import { FC } from "react";
import { useIntl } from "react-intl";
import styles from "./RemoteCall.module.css";

interface RemoteAccessButtonsProps {
  onEnd: () => void;
  captureEnabled?: boolean;
  onCapture: () => void;
  onStartWork?: () => void;
  workStarted?: boolean;
}
export const RemoteAccessButtons: FC<RemoteAccessButtonsProps> = (props) => {
  const { onEnd, captureEnabled, onCapture, onStartWork, workStarted } = props;
  const intl = useIntl();
  return (
    <Grid container className={styles.buttonBarUnder}>
      {onStartWork && !workStarted && (
        <IconButton
          title={intl.formatMessage({ id: "remoteAccess.captureScreen" })}
          onClick={onStartWork}
          color="primary"
          disabled={workStarted}
        >
          <Build />
        </IconButton>
      )}
      {captureEnabled && (
        <IconButton
          title={intl.formatMessage({ id: "remoteAccess.captureScreen" })}
          onClick={onCapture}
          color="inherit"
        >
          <AddAPhoto />
        </IconButton>
      )}
      <IconButton
        title={intl.formatMessage({ id: "remoteAccess.endCall" })}
        onClick={onEnd}
        color="inherit"
        size="large"
      >
        <CallEnd />
      </IconButton>
    </Grid>
  );
};
